import { postJson } from "./request.service";
import CRM_URL, { CRM_TOKEN } from "../constants/crmUrl";

const INBOUND_PATH = "/api/v1/crm/inbound/li-soroban";

// The new CRM only handles Dnipro leads. Match on the stable city id / program
// slug (id 82 / "dnepr") rather than the localized title — and never by
// substring, since "vdneprovsk" (Верхньодніпровськ) also contains "dnepr".
const DNIPRO_CITY_ID = 82;
const DNIPRO_PROGRAM_TITLE = "dnepr";

export const isDniproCity = (city) =>
  !!city &&
  (String(city.id) === String(DNIPRO_CITY_ID) ||
    city.program_title === DNIPRO_PROGRAM_TITLE);

// Masked input (e.g. "+38 (050) 123 45 67") -> "+380501234567".
const normalizePhone = (phone) => {
  if (!phone) return null;
  const digits = phone.replace(/\D/g, "");
  return digits ? `+${digits}` : null;
};

// Map the data we already collect for Bitrix into the CRM payload.
// All CRM fields are optional, so we only include what we actually have.
const buildPayload = ({ phone, contact_person, city, office, group }) => {
  const payload = {};
  const normalizedPhone = normalizePhone(phone);
  if (normalizedPhone) payload.phones = [normalizedPhone];
  if (contact_person) payload.first_name = contact_person;
  if (city) payload.city = city;
  if (office) payload.preferred_location = office;
  if (group) payload.comment = group;
  payload.source = window.location.hostname;
  payload.source_information = window.location.href;
  return payload;
};

export default (() => {
  return {
    SendLead: async (data) => {
      const payload = buildPayload(data);
      if (!payload.phones) return;
      return await postJson(`${CRM_URL}${INBOUND_PATH}?token=${CRM_TOKEN}`, {
        payload,
      });
    },
  };
})();
